<template>
  <div class="banner-container">
    <div class="banner-slider">
      <div
          v-for="(item, index) in bannerList"
          :key="index"
          class="banner-item"
          :class="{ active: currentIndex === index }"
          :style="{ backgroundImage: `url(${item.image})` }"
      >
        <div class="banner-content">
          <h1 class="banner-title">{{ getItemTitle(item) }}</h1>
          <p class="banner-desc">{{ getItemDesc(item) }}</p>
          <div v-if="item.bottomTextsKey || item.bottomTexts" class="banner-tags">
            <span v-for="(tag, i) in getBottomTexts(item)" :key="i" class="banner-tag">{{ tag }}</span>
          </div>
          <button v-if="item.btnText" class="banner-btn" @click="handleMore(item)">
            {{ item.btnText }}
          </button>
        </div>

      </div>
    </div>




    <!-- 左右箭头 -->
    <button v-if="bannerList.length > 1" class="arrow arrow-left" @click="prevSlide">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="white" />
      </svg>
    </button>
    <button v-if="bannerList.length > 1" class="arrow arrow-right" @click="nextSlide">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M8.59 16.59L10 18L16 12L10 6L8.59 7.41L13.17 12L8.59 16.59Z" fill="white" />
      </svg>
    </button>

    <!-- 底部指示器 -->
    <div class="indicators" v-if="bannerList.length > 1">
      <span
          v-for="(item, index) in bannerList"
          :key="index"
          class="indicator"
          :class="{ active: currentIndex === index }"
          @click="goToSlide(index)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    bannerList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentIndex: 0,
      timer: null
    }
  },
  mounted() {
    this.autoPlay()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    getItemTitle(item) {
      return item.titleKey ? this.$t(item.titleKey) : item.title
    },
    getItemDesc(item) {
      return item.descKey ? this.$t(item.descKey) : item.desc
    },
    getBottomTexts(item) {
      if (item.bottomTextsKey) {
        return this.$t(item.bottomTextsKey) || []
      }
      return item.bottomTexts || []
    },
    autoPlay() {
      this.timer = setInterval(() => {
        this.nextSlide()
      }, 15000)
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.bannerList.length
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.bannerList.length) % this.bannerList.length
    },
    goToSlide(index) {
      this.currentIndex = index
      this.resetTimer()
    },
    resetTimer() {
      clearInterval(this.timer)
      this.autoPlay()
    },
    handleMore(item) {
      this.$emit('handleMore', item)
    }
  }
}
</script>

<style scoped>
.banner-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #000;
  margin: 0;
  padding: 0;
}

.banner-slider {
  width: 100%;
  height: 100%;
  position: relative;
}

.banner-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.8s ease;
  background-size: cover;
  object-fit: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: translateZ(0);
}

.banner-item.active {
  opacity: 1;
  z-index: 1;
}

.banner-content {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  z-index: 2;
  color: #fff;
  max-width: 600px;
}

.banner-title {
  white-space: nowrap;
  font-family: Source Han Sans SC, sans-serif;
  font-weight: bold;
  font-size: 52px;
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-shadow: 0px 2px 6px #000014;
  font-style: normal;
  text-transform: none;

}

.banner-desc {
  font-size: 20px;
  line-height: 1.7;
  margin-bottom: 24px;
  text-shadow: 0 2px 8px rgba(0,0,0,0.6);
}

.banner-tags {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 36px;
}

.banner-tag {
  padding: 6px 14px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 20px;
  font-size: 14px;
  color: #fff;
  background: rgba(0, 0, 0, 0.2);
}

.banner-btn {
  padding: 5px 20px;
  font-size: 16px;
  color: #fff;
  background: transparent;
  border: 2px solid #fff;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s;
}

.banner-btn:hover {
  background: #fff;
  color: #000;
}





/* 箭头 */
.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(0,0,0,0.3);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.arrow-left {
  left: 30px;
}

.arrow-right {
  right: 30px;
}

.indicators {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  display: flex;
  gap: 14px;
}

.indicator {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgba(255,255,255,0.5);
  cursor: pointer;
  transition: all 0.3s;
}

.indicator.active {
  width: 34px;
  border-radius: 7px;
  background: #fff;
}

@media (max-width: 768px) {
  .banner-content {
    left: 5%;
    right: 5%;
    max-width: 100%;
  }
  .banner-title {
    font-size: 36px;
  }
  .banner-desc {
    font-size: 16px;
  }
  .bottom-left-fixed {
    display: none;
  }
}
</style>